/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedReportIndexImport } from './routes/_authenticated/report/index'
import { Route as AuthenticatedInterventiIndexImport } from './routes/_authenticated/interventi/index'
import { Route as GuestAuthLoginImport } from './routes/_guest/auth/login'
import { Route as AuthenticatedInterventiRiparazioneImport } from './routes/_authenticated/interventi/riparazione'
import { Route as AuthenticatedInterventiNuovoImport } from './routes/_authenticated/interventi/nuovo'
import { Route as AuthenticatedImpostazioniUtentiImport } from './routes/_authenticated/impostazioni/utenti'
import { Route as AuthenticatedImpostazioniCommittentiImport } from './routes/_authenticated/impostazioni/committenti'
import { Route as AuthenticatedFFotoInterventoIdImport } from './routes/_authenticated/f/$fotoInterventoId'
import { Route as AuthenticatedInterventiVisualizzaInterventoIdImport } from './routes/_authenticated/interventi/visualizza/$interventoId'
import { Route as AuthenticatedInterventiModificaInterventoIdImport } from './routes/_authenticated/interventi/modifica/$interventoId'

// Create/Update Routes

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedReportIndexRoute = AuthenticatedReportIndexImport.update({
  id: '/report/',
  path: '/report/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedInterventiIndexRoute =
  AuthenticatedInterventiIndexImport.update({
    id: '/interventi/',
    path: '/interventi/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const GuestAuthLoginRoute = GuestAuthLoginImport.update({
  id: '/_guest/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedInterventiRiparazioneRoute =
  AuthenticatedInterventiRiparazioneImport.update({
    id: '/interventi/riparazione',
    path: '/interventi/riparazione',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedInterventiNuovoRoute =
  AuthenticatedInterventiNuovoImport.update({
    id: '/interventi/nuovo',
    path: '/interventi/nuovo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedImpostazioniUtentiRoute =
  AuthenticatedImpostazioniUtentiImport.update({
    id: '/impostazioni/utenti',
    path: '/impostazioni/utenti',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedImpostazioniCommittentiRoute =
  AuthenticatedImpostazioniCommittentiImport.update({
    id: '/impostazioni/committenti',
    path: '/impostazioni/committenti',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedFFotoInterventoIdRoute =
  AuthenticatedFFotoInterventoIdImport.update({
    id: '/f/$fotoInterventoId',
    path: '/f/$fotoInterventoId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedInterventiVisualizzaInterventoIdRoute =
  AuthenticatedInterventiVisualizzaInterventoIdImport.update({
    id: '/interventi/visualizza/$interventoId',
    path: '/interventi/visualizza/$interventoId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedInterventiModificaInterventoIdRoute =
  AuthenticatedInterventiModificaInterventoIdImport.update({
    id: '/interventi/modifica/$interventoId',
    path: '/interventi/modifica/$interventoId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/f/$fotoInterventoId': {
      id: '/_authenticated/f/$fotoInterventoId'
      path: '/f/$fotoInterventoId'
      fullPath: '/f/$fotoInterventoId'
      preLoaderRoute: typeof AuthenticatedFFotoInterventoIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/impostazioni/committenti': {
      id: '/_authenticated/impostazioni/committenti'
      path: '/impostazioni/committenti'
      fullPath: '/impostazioni/committenti'
      preLoaderRoute: typeof AuthenticatedImpostazioniCommittentiImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/impostazioni/utenti': {
      id: '/_authenticated/impostazioni/utenti'
      path: '/impostazioni/utenti'
      fullPath: '/impostazioni/utenti'
      preLoaderRoute: typeof AuthenticatedImpostazioniUtentiImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/interventi/nuovo': {
      id: '/_authenticated/interventi/nuovo'
      path: '/interventi/nuovo'
      fullPath: '/interventi/nuovo'
      preLoaderRoute: typeof AuthenticatedInterventiNuovoImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/interventi/riparazione': {
      id: '/_authenticated/interventi/riparazione'
      path: '/interventi/riparazione'
      fullPath: '/interventi/riparazione'
      preLoaderRoute: typeof AuthenticatedInterventiRiparazioneImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_guest/auth/login': {
      id: '/_guest/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof GuestAuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/interventi/': {
      id: '/_authenticated/interventi/'
      path: '/interventi'
      fullPath: '/interventi'
      preLoaderRoute: typeof AuthenticatedInterventiIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/report/': {
      id: '/_authenticated/report/'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AuthenticatedReportIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/interventi/modifica/$interventoId': {
      id: '/_authenticated/interventi/modifica/$interventoId'
      path: '/interventi/modifica/$interventoId'
      fullPath: '/interventi/modifica/$interventoId'
      preLoaderRoute: typeof AuthenticatedInterventiModificaInterventoIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/interventi/visualizza/$interventoId': {
      id: '/_authenticated/interventi/visualizza/$interventoId'
      path: '/interventi/visualizza/$interventoId'
      fullPath: '/interventi/visualizza/$interventoId'
      preLoaderRoute: typeof AuthenticatedInterventiVisualizzaInterventoIdImport
      parentRoute: typeof AuthenticatedImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedFFotoInterventoIdRoute: typeof AuthenticatedFFotoInterventoIdRoute
  AuthenticatedImpostazioniCommittentiRoute: typeof AuthenticatedImpostazioniCommittentiRoute
  AuthenticatedImpostazioniUtentiRoute: typeof AuthenticatedImpostazioniUtentiRoute
  AuthenticatedInterventiNuovoRoute: typeof AuthenticatedInterventiNuovoRoute
  AuthenticatedInterventiRiparazioneRoute: typeof AuthenticatedInterventiRiparazioneRoute
  AuthenticatedInterventiIndexRoute: typeof AuthenticatedInterventiIndexRoute
  AuthenticatedReportIndexRoute: typeof AuthenticatedReportIndexRoute
  AuthenticatedInterventiModificaInterventoIdRoute: typeof AuthenticatedInterventiModificaInterventoIdRoute
  AuthenticatedInterventiVisualizzaInterventoIdRoute: typeof AuthenticatedInterventiVisualizzaInterventoIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedFFotoInterventoIdRoute: AuthenticatedFFotoInterventoIdRoute,
  AuthenticatedImpostazioniCommittentiRoute:
    AuthenticatedImpostazioniCommittentiRoute,
  AuthenticatedImpostazioniUtentiRoute: AuthenticatedImpostazioniUtentiRoute,
  AuthenticatedInterventiNuovoRoute: AuthenticatedInterventiNuovoRoute,
  AuthenticatedInterventiRiparazioneRoute:
    AuthenticatedInterventiRiparazioneRoute,
  AuthenticatedInterventiIndexRoute: AuthenticatedInterventiIndexRoute,
  AuthenticatedReportIndexRoute: AuthenticatedReportIndexRoute,
  AuthenticatedInterventiModificaInterventoIdRoute:
    AuthenticatedInterventiModificaInterventoIdRoute,
  AuthenticatedInterventiVisualizzaInterventoIdRoute:
    AuthenticatedInterventiVisualizzaInterventoIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/f/$fotoInterventoId': typeof AuthenticatedFFotoInterventoIdRoute
  '/impostazioni/committenti': typeof AuthenticatedImpostazioniCommittentiRoute
  '/impostazioni/utenti': typeof AuthenticatedImpostazioniUtentiRoute
  '/interventi/nuovo': typeof AuthenticatedInterventiNuovoRoute
  '/interventi/riparazione': typeof AuthenticatedInterventiRiparazioneRoute
  '/auth/login': typeof GuestAuthLoginRoute
  '/interventi': typeof AuthenticatedInterventiIndexRoute
  '/report': typeof AuthenticatedReportIndexRoute
  '/interventi/modifica/$interventoId': typeof AuthenticatedInterventiModificaInterventoIdRoute
  '/interventi/visualizza/$interventoId': typeof AuthenticatedInterventiVisualizzaInterventoIdRoute
}

export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/f/$fotoInterventoId': typeof AuthenticatedFFotoInterventoIdRoute
  '/impostazioni/committenti': typeof AuthenticatedImpostazioniCommittentiRoute
  '/impostazioni/utenti': typeof AuthenticatedImpostazioniUtentiRoute
  '/interventi/nuovo': typeof AuthenticatedInterventiNuovoRoute
  '/interventi/riparazione': typeof AuthenticatedInterventiRiparazioneRoute
  '/auth/login': typeof GuestAuthLoginRoute
  '/interventi': typeof AuthenticatedInterventiIndexRoute
  '/report': typeof AuthenticatedReportIndexRoute
  '/interventi/modifica/$interventoId': typeof AuthenticatedInterventiModificaInterventoIdRoute
  '/interventi/visualizza/$interventoId': typeof AuthenticatedInterventiVisualizzaInterventoIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/f/$fotoInterventoId': typeof AuthenticatedFFotoInterventoIdRoute
  '/_authenticated/impostazioni/committenti': typeof AuthenticatedImpostazioniCommittentiRoute
  '/_authenticated/impostazioni/utenti': typeof AuthenticatedImpostazioniUtentiRoute
  '/_authenticated/interventi/nuovo': typeof AuthenticatedInterventiNuovoRoute
  '/_authenticated/interventi/riparazione': typeof AuthenticatedInterventiRiparazioneRoute
  '/_guest/auth/login': typeof GuestAuthLoginRoute
  '/_authenticated/interventi/': typeof AuthenticatedInterventiIndexRoute
  '/_authenticated/report/': typeof AuthenticatedReportIndexRoute
  '/_authenticated/interventi/modifica/$interventoId': typeof AuthenticatedInterventiModificaInterventoIdRoute
  '/_authenticated/interventi/visualizza/$interventoId': typeof AuthenticatedInterventiVisualizzaInterventoIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/'
    | '/f/$fotoInterventoId'
    | '/impostazioni/committenti'
    | '/impostazioni/utenti'
    | '/interventi/nuovo'
    | '/interventi/riparazione'
    | '/auth/login'
    | '/interventi'
    | '/report'
    | '/interventi/modifica/$interventoId'
    | '/interventi/visualizza/$interventoId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/f/$fotoInterventoId'
    | '/impostazioni/committenti'
    | '/impostazioni/utenti'
    | '/interventi/nuovo'
    | '/interventi/riparazione'
    | '/auth/login'
    | '/interventi'
    | '/report'
    | '/interventi/modifica/$interventoId'
    | '/interventi/visualizza/$interventoId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/'
    | '/_authenticated/f/$fotoInterventoId'
    | '/_authenticated/impostazioni/committenti'
    | '/_authenticated/impostazioni/utenti'
    | '/_authenticated/interventi/nuovo'
    | '/_authenticated/interventi/riparazione'
    | '/_guest/auth/login'
    | '/_authenticated/interventi/'
    | '/_authenticated/report/'
    | '/_authenticated/interventi/modifica/$interventoId'
    | '/_authenticated/interventi/visualizza/$interventoId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuestAuthLoginRoute: typeof GuestAuthLoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuestAuthLoginRoute: GuestAuthLoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_guest/auth/login"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/",
        "/_authenticated/f/$fotoInterventoId",
        "/_authenticated/impostazioni/committenti",
        "/_authenticated/impostazioni/utenti",
        "/_authenticated/interventi/nuovo",
        "/_authenticated/interventi/riparazione",
        "/_authenticated/interventi/",
        "/_authenticated/report/",
        "/_authenticated/interventi/modifica/$interventoId",
        "/_authenticated/interventi/visualizza/$interventoId"
      ]
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/f/$fotoInterventoId": {
      "filePath": "_authenticated/f/$fotoInterventoId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/impostazioni/committenti": {
      "filePath": "_authenticated/impostazioni/committenti.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/impostazioni/utenti": {
      "filePath": "_authenticated/impostazioni/utenti.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/interventi/nuovo": {
      "filePath": "_authenticated/interventi/nuovo.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/interventi/riparazione": {
      "filePath": "_authenticated/interventi/riparazione.tsx",
      "parent": "/_authenticated"
    },
    "/_guest/auth/login": {
      "filePath": "_guest/auth/login.tsx"
    },
    "/_authenticated/interventi/": {
      "filePath": "_authenticated/interventi/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/report/": {
      "filePath": "_authenticated/report/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/interventi/modifica/$interventoId": {
      "filePath": "_authenticated/interventi/modifica/$interventoId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/interventi/visualizza/$interventoId": {
      "filePath": "_authenticated/interventi/visualizza/$interventoId.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
